import React, {Component} from 'react';
import ListDesignerHoc from "../../../../../HocHelpers/ListDesignerHoc";
import FormField from "../../../../../Utils/Form/Fields/FormField";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button";

const styles = () => ({
    table: {
        width: '100%',
        borderSpacing: 0,
        border: '1px solid #fff',
        borderCollapse: 'collapse'
    },
    tableCellLabel: {
        paddingLeft: 10,
        width: '105px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    tableCell: {
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
});


class DeveloperSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: {
                logQuery: {
                    name: 'logQuery',
                    type: 'switch',
                    path: 'devSettings.logQuery'
                },
                previewRows: {
                    name: 'previewRows',
                    type: 'number',
                    path: 'devSettings.previewRows'
                }
            }
        }
    }

    render() {
        const {classes, data, generalInfoChange, previewRowsChange, loadSampleData, loadedSampleData} = this.props;
        const {fields} = this.state;
        let currentConnector = this.props.data?.source?.inPlaceConnection?.connector;
        return (
            <table className={classes.table}>
                <tbody>
                <tr>
                    <td className={classes.tableCellLabel}>Log Query</td>
                    <td className={classes.tableCell}>
                        <FormField field={fields.logQuery}
                                   onChange={generalInfoChange}
                                   path={fields.logQuery.path}
                                   values={data}/>
                    </td>
                </tr>
                <tr>
                    <td className={classes.tableCellLabel}>Preview Rows</td>
                    <td className={classes.tableCell}>
                        <FormField field={fields.previewRows}
                                   onChange={previewRowsChange}
                                   path={fields.previewRows.path}
                                   values={data}/>
                    </td>
                </tr>
                {currentConnector === 'sbEntity' && (
                    <tr>
                        <td className={classes.tableCellLabel}>Sample Data</td>
                        <td className={classes.tableCell}>
                            <Button
                                disabled={loadedSampleData}
                                color="primary"
                                variant={'outlined'}
                                size={'small'}
                                style={{
                                    height: 25,
                                    margin: '3px 0 3px 3px'
                                }}
                                onClick={loadSampleData}
                            >
                                {loadedSampleData ? "Loaded yet" : "Load"}
                            </Button>
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
        );
    }
}


export default withStyles(styles)(ListDesignerHoc(DeveloperSettings));